import GS from "../assets/icons/google-scholar.svg";
import RG from "../assets/icons/researchgate.svg";
import GH from "../assets/icons/github.svg";

const icons = {
  GS,
  RG,
  GH,
};

export default icons;
